import { FC, useCallback, useEffect, useState }  from 'react';
import { agora } from '../../../environments/voice-call-variables';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { IJoinArgs } from '@interfaces/videocall/videocall';
import { setVideoAlert, setVideoCallGroupInProcess } from '@redux/slices/video-call/videoCall-alert.slice';
import VideocallGroup from '@hubio/group-videocall-lib/Videocall/videocall';

interface IVideocallGroupWrapper
{
    onCreateSocketVideo?: () => void
}

const VideocallGroupWrapper: FC<IVideocallGroupWrapper> = (props) => {
    const session = useSelector((state: RootState) => state.session);
    const videoCallR = useSelector((state: RootState) => state.videoCall.videoCall)
    const videoCallAlert = useSelector((state: RootState) => state.videoAlert);
    const audioDefault = videoCallAlert.videoAlert.audioEnabled;
    const videoDefault = videoCallAlert.videoAlert.videoEnabled;

    const [controlsValues, setControlsValues] = useState<IJoinArgs>();
    const dispatch = useDispatch();

    useEffect(() => {
        if(audioDefault === undefined || videoDefault === undefined)
            return;
        setControlsValues({
            audio: audioDefault,
            video: videoDefault
        });
        console.debug('got a change in controls')
    }, [audioDefault, videoDefault]);

    useEffect(() => {
        console.debug('videoCallR', videoCallR)
    }, [videoCallR])

    /**
     * Clean redux videocall data
     */
    const leaveVideocall = () => {
        dispatch(setVideoCallGroupInProcess({videocallGroupInProgress: false}));
        const listener = {
            username: null,
            newVideoCall: false
        }
        dispatch(setVideoAlert(listener));
        if(videoCallR)
        {
            dispatch(setVideoCallGroupInProcess({videocallGroupInProgress: false}));
        }
    }

    const checkAvailable = useCallback(() => {
        const res = controlsValues !== undefined && 
            session.username !== undefined &&
            videoCallAlert.videoAlert.videocallGroupInProgress === true && 
            videoCallR?.room !== undefined && 
            videoCallR?.token !== undefined;

        // console.groupCollapsed("Check values");
        // console.log("controlsValues", controlsValues);
        // console.log("session.username", session.username);
        // console.log("videoCallAlert.videoAlert.videocallGroupInProgress", videoCallAlert.videoAlert.videocallGroupInProgress);
        // console.log("currentVideoCall?.room", videoCallR?.room);
        // console.log("currentVideoCall?.token", videoCallR?.token);
        // console.groupEnd();

        // console.log(res);

        return res;
    }, [controlsValues, session.username, videoCallAlert.videoAlert.videocallGroupInProgress, videoCallR?.room, videoCallR?.token]);

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {  
                checkAvailable() && controlsValues !== undefined &&
                <VideocallGroup
                    appId={agora.appID}
                    channelName={videoCallR?.room ?? ''}
                    initialMediaArgs={controlsValues}
                    myUsername={session.username ?? ''}
                    token={videoCallR?.token ?? ''}
                    onLeaveChannel={leaveVideocall}
                />
            }
        </>
    )
}

export default VideocallGroupWrapper;
